import React                                         from 'react'
import { useState, useRef }                          from 'react'
import { CToaster, CToast, CToastBody, CToastClose } from '@coreui/react'

export const useToast = () => {
  const [toast, addToast] = useState(0)
  const toasterRef = useRef()

  const toastTemplate = (msg, type) => (
    <CToast autohide={ true } color={ type } className="align-items-center" placement="top-end">
      <div className="d-flex">
        <CToastBody>{ typeof msg === 'string' ? msg : (msg?.message || 'Unknown error') }</CToastBody>
        <CToastClose className="me-2 m-auto" />
      </div>
    </CToast>
  )

  const toaster = <CToaster ref={ toasterRef } push={ toast } placement="top-end" />

  const pushToast = (msg, type) => addToast(toastTemplate(msg, type))

  return {
    pushToast,
    toaster,
  }
}
